module.exports = __webpack_public_path__ + "static/media/ribbon-small.67825cab.gif";